import { SLUG_DEFS, type SlugDef } from './broadcastSlugs';

// Phase 6B (P3) — the survey-scoped slug catalogue. The invite email/SMS reuses
// the entire broadcast slug set (contact / static / account-link tokens, all
// resolved server-side at send time in Phase C) PLUS {survey_link}: the
// recipient's unique /s/:token URL. Survey CONTENT (intro/outro/questions) is
// deliberately slug-free (NEW-3) — this list is invite-only.
//
// Defined as its own list rather than mutating SLUG_DEFS so the broadcast picker
// is untouched (P3). The SlugPicker / SlugTextField / MarkdownEditor accept this
// via their additive `defs` prop.

export const SURVEY_LINK_SLUG: SlugDef = {
  token: 'survey_link',
  label: 'Survey link',
  category: 'static',
  renderKind: 'value',
  description: "The recipient's unique link to open the survey. Required in every invite.",
  example: 'https://agency.kyck.marketing/s/AbC123…',
};

export const SURVEY_SLUG_DEFS: SlugDef[] = [SURVEY_LINK_SLUG, ...SLUG_DEFS];
